import React, { useState, useEffect } from "react";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";
import { BaseButtons, CheckInput } from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";

const Accounts = ({
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [companyServices, setCompanyServices] = useState([]);

  const calculateTotalSubscription = () => {
    let baseArray = [...companyServices];
    let totalAmount = [];
    let totalSumAmount;

    if (companyInformation) {
      baseArray.map((service) =>
        service.value === true ? totalAmount.push(Number(499.99)) : null
      );
    }
    const sum = totalAmount.reduce((partialSum, a) => partialSum + a, 0);

    return sum;
  };
  useEffect(() => {
    if (companyInformation) {
      setCompanyServices(companyInformation.companyServices);
    }
  }, []);
  //   useEffect(() => {
  //     if (companyServices) {
  //       calculateTotalSubscription();
  //     }
  //   }, [companyServices]);

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "row",

        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          flex: 0.5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          height: "100%",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 15 }}
        >
          <div style={{ fontWeight: "bold", marginRight: 10 }}>
            DEBIT ORDER DOCUMENT
          </div>{" "}
          <div style={{ minWidth: 10 }} />
          <BaseButtons
            label={"DOWNLOAD BLANK"}
            borderRadius={8}
            backgroundColor={colors.secondaryDarkBlue}
            width={180}
            height={35}
          />
        </div>
        <div
          style={{
            height: "70%",
            minWidth: 430,
            maxWidth: 430,

            backgroundColor: colors.white,
            WebkitBoxShadow: "0px 0px 7px 2px #00000050",
            marginBottom: 10,
          }}
        ></div>
        <div style={{ display: "flex", width: 470, alignItems: "center" }}>
          <ImageUploadAWS
            mini={true}
            labelTitle={"UPLOAD DEBIT ORDER DOCUMENT"}
            width={310}
            size={"100%"}
          />
          <div style={{ marginTop: 35, marginLeft: 10 }}>
            <BaseButtons
              label={"SAVE UPLOAD"}
              borderRadius={8}
              backgroundColor={colors.secondaryDarkBlue}
              width={120}
              height={55}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 0.5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",

          height: "100%",
          justifyContent: "center",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: "bold", marginBottom: 10 }}>
          COST BREAKDOWN
        </div>
        <div
          style={{
            height: 500,
            marginTop: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            backgroundColor: colors.white,
            borderRadius: 10,
            alignItems: "center",
            padding: 10,
            WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          }}
        >
          {companyInformation
            ? companyInformation.companyServices.map((service, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    <CheckInput
                      label={service.serviceType}
                      selected={service.value}
                    />
                    <div
                      style={{
                        width: 250,
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>R 499.99</div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          opacity: 0.7,
                          marginTop: 5,
                        }}
                      >
                        COST
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
        <div
          style={{
            width: "60%",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: 16,
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          TOTAL MONTHLY COST:{" "}
        </div>
        <div
          style={{
            width: "60%",
            textAlign: "right",
            fontSize: 34,
            fontWeight: "bold",
          }}
        >
          {companyServices
            ? "R " + calculateTotalSubscription().toFixed(2)
            : "loading"}{" "}
        </div>
      </div>
    </div>
  );
};

export default Accounts;
